import { ReactNode } from 'react';
import { NodeContainer } from '@/GraphEditor/drawingLayer/nodeComposition/NodeContainer';
import { NodeContentStandardLayout } from '@/GraphEditor/drawingLayer/nodeComposition/NodeContentStandardLayout';
import { FunctionNodeInstance } from '@glueapp/graph-types';
import { InPortList } from '@/GraphEditor/drawingLayer/nodeComposition/InPortList';
import { OutPortList } from '@/GraphEditor/drawingLayer/nodeComposition/OutPortList';
import { InherentInPort, InherentOutPort } from './Ports';
import { useCurrentNode } from '@/GraphEditor/drawingLayer/contexts/CurrentNodeContext';
import { NodeBackground } from './NodeBackground';
import { useNodeEvents } from '@/GraphEditor/drawingLayer/contexts/NodeEventsContext';

interface Props {
    nodeInstance: FunctionNodeInstance;
    functionName?: string;
    children?: ReactNode;
}

export const FunctionNodeLayout: React.FC<Props> = ({ nodeInstance, functionName, children }) => {
    const node = useCurrentNode();
    const { onDoubleClick } = useNodeEvents();

    // Use the function name from state or props, fallback to node name
    const displayName = functionName || node.name || 'Function';

    return (
        <NodeContainer ariaLabel={displayName}>
            <NodeBackground color="#8B5CF6">
                <NodeContentStandardLayout
                    name={displayName}
                    renderInPorts={() => <InPortList ports={nodeInstance.inPorts} />}
                    renderOutPorts={() => <OutPortList ports={nodeInstance.outPorts} />}
                    renderInherentInPort={() => <InherentInPort />}
                    renderInherentOutPort={() => <InherentOutPort />}
                >
                    {children || (
                        <div
                            onDoubleClick={onDoubleClick}
                            style={{
                                padding: '4px 8px',
                                fontSize: '10px',
                                opacity: 0.8,
                                fontStyle: 'italic',
                                textAlign: 'center',
                            }}
                        >
                            Double-click to edit
                        </div>
                    )}
                </NodeContentStandardLayout>
            </NodeBackground>
        </NodeContainer>
    );
};
